import { setApiUrl } from '@repo/utils';

// Set the API URL for this specific application
setApiUrl('https://fittools.cc/api');

export * from '@repo/utils';
